import { SiteFiltersStore } from "../store";

export function updateLocalAuthorities(localAuthorities: string[], store: SiteFiltersStore) {
  store.localAuthorities = localAuthorities;
}
